import { makeAutoObservable, runInAction } from 'mobx';

export class ModalStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.currentModal = null;
    this.modalsProps = {};
    makeAutoObservable(this);
  }

  open = (name, modalProps) => {
    runInAction(() => {
      this.currentModal = name;
      if (modalProps)
        this.modalsProps = { ...this.modalsProps, [name]: modalProps };
    });
  };

  close = () => {
    runInAction(() => {
      if (this.currentModal)
        this.modalsProps = { ...this.modalsProps, [this.currentModal]: null };
      this.currentModal = null;
    });
  };

  isOpen = () => this.currentModal !== null;
}
